import { render, staticRenderFns } from "./CuponesCRUD.vue?vue&type=template&id=43d51af0"
import script from "./CuponesCRUD.vue?vue&type=script&lang=js"
export * from "./CuponesCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports